export default __webpack_public_path__ + "media/images/images_v2/ongletwhite-left-eb2cae4379b87571aa6d860407a3a867.png";